<template>
  <div class="section-category section-full" @scroll="onScroll">
    <div class="section-cashcalc px-2">
      <h2 class="ttl2 popup-header" v-translate>cash calculator</h2>
      <div class="row">
        <div class="col-sm-6 cash">
          <table class="table">
            <thead class="thead-light">
              <tr class="border-left text-uppercase">
                <th width="35%" v-translate>Coin</th>
                <th width="30%" v-translate>Qty</th>
                <th width="5%"></th>
                <th width="30%" v-translate>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr class="border-left" v-for="coin in coins" :key="coin.id">
                <td>
                  <span class="sp-value">{{ coin.value }}</span>
                  <span class="xl">x</span>
                </td>
                <td>
                  <input-pad
                    :item="coin"
                    :property="'qty'"
                    :attributes="{'min': '0', 'class': 'form-control'}"
                  />
                </td>
                <td>=</td>
                <td>
                  <span>{{ multiple(coin) }}</span>
                </td>
              </tr>
              <tr class="bg-cash">
                <td colspan="2" class="text-left" v-translate>Total Coin</td>
                <td colspan="2">
                  <span class="number-tt">{{ totalType(coins) | currency }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-sm-6 cash">
          <table class="table">
            <thead class="thead-light text-uppercase">
              <tr class="border-left">
                <th width="35%" v-translate>Bill</th>
                <th width="30%" v-translate>Qty</th>
                <th width="5%"></th>
                <th width="30%" v-translate>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr class="border-left" v-for="cash in cashes" :key="cash.id">
                <td>
                  <span class="sp-value">{{ cash.value }}</span>
                  <span class="xl">x</span>
                </td>
                <td>
                  <input-pad
                    :item="cash"
                    :property="'qty'"
                    :attributes="{'min': '0', 'class': 'form-control'}"
                  />
                </td>
                <td>=</td>
                <td>
                  <span>{{ multiple(cash) }}</span>
                </td>
              </tr>
              <tr class="bg-cash">
                <td colspan="2" class="text-left" v-translate>Total Bill</td>
                <td colspan="2">
                  <span class="number-tt">{{ totalType(cashes) | currency }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="inner-total">
          <span class="txt-tt text-uppercase" v-translate>Total:</span>
          <span class="number-tt">{{ total | currency }}</span>

          <div class="btns-footer mt-3">
            <button
              class="btn px-5"
              :class="hasShiftCurrentAction ? 'btn-confirm' : 'btn-cancel'"
              @click="handleClose"
            >
              {{ hasShiftCurrentAction ? this.$gettext('next') : this.$gettext('close') }}
            </button>
            <button
              v-if="!hasShiftCurrentAction"
              class="btn px-5 btn-confirm"
              @click="printCashCal"
            >{{ this.$gettext('print') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import ShiftService from "@/services/ShiftService";
import {
  UPDATE_SHIFT,
  RESET_ALL_CURRENCIES,
  SET_SHIFT_CURRENT_ACTION,
  ON_INPUT_PAD_BLUR,
  SET_MESSAGE_MODAL
} from "@/store/mutation-types";

export default {
  name: "CashCalc",
  computed: {
    hasShiftCurrentAction() {
      return this.currentAction === "start" || this.currentAction === "end";
    },
    ...mapState({
      coins: state => state.currency.coins,
      cashes: state => state.currency.cashes,
      currentAction: state => state.shift.currentAction
    }),
    ...mapGetters(["totalType", "total"])
  },
  methods: {
    async handleClose() {
      if (this.hasShiftCurrentAction) {
        await this.printCalculator();
      }

      if (this.currentAction === "end") {
        this.$router.push({ name: "shift-report" });
      } else if (this.currentAction === "start") {
        const shift = await ShiftService.start(this.total);
        const shifts = this.getArray("shifts");
        const lastKey = Object.keys(shifts)[Object.keys(shifts).length - 1];
        this.$store.commit(UPDATE_SHIFT, shifts[lastKey]);
        this.$store.commit(SET_SHIFT_CURRENT_ACTION, "");
        this.$router.push({ name: "order" });
      } else {
        this.$router.push({ name: "order" });
      }
    },
    multiple({ value, qty }) {
      return this.$options.filters.decimal(value * qty);
    },
    onScroll() {
      this.$store.commit(ON_INPUT_PAD_BLUR, true);
    },
    async printCashCal() {
      await this.printCalculator();
      this.$router.push({ name: "order" });
    },

    async printCalculator() {
      const data = {
        coin: [],
        cash: []
      };
      this.coins.forEach(({ value, qty }) => {
        data.coin.push({
          bill: value,
          qty,
          total: value * qty
        });
      });
      this.cashes.forEach(({ value, qty }) => {
        data.cash.push({
          bill: value,
          qty,
          total: value * qty
        });
      });
      if (this.currentAction === "end") {
        data.endTime = Date.now();
      }
      const res = await ShiftService.printCashCal(data);
      if (res && !res.error) {
        await this.$store.dispatch("print", {billData: res});
      } else {
        this.$store.commit(SET_MESSAGE_MODAL, res);
      }
    }
  },
  mounted() {
    this.$store.dispatch('resetCashCalc');
  }
};
</script>
